import { useEffect, useRef, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Check } from "lucide-react";
import { CheckoutForm, RecoverPro } from "@/components/ProCheckout";
import { ProTrial } from "@/components/ProTrial";

const TIERS = [
  { id: "starter", name: "Starter", price: "Gratis", note: "per sempre", features: ["3 generazioni al giorno", "Valutazione AI base", "Archivio idee nel browser"] },
  { id: "pro", name: "Pro", price: "€19", note: "/mese", popular: true, features: ["7 giorni di prova gratuita", "Generazioni illimitate", "Piani d'azione 30 giorni illimitati", "Verifica illimitata delle tue idee", "Analisi dei concorrenti", "Esportazione PDF"] },
  { id: "team", name: "Team", price: "€49", note: "/mese", features: ["Tutto il piano Pro", "Fino a 5 membri", "Archivio condiviso", "Supporto prioritario"] },
];

export default function Pro() {
  const [plan, setPlan] = useState("pro");
  const formRef = useRef(null);
  const tier = TIERS.find((t) => t.id === plan);
  const { hash } = useLocation();
  const [params] = useSearchParams();
  const presetEmail = params.get("email") || "";

  useEffect(() => {
    if (hash) setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "center" }), 100);
  }, [hash]);

  const choose = (id) => {
    if (id === "starter") return;
    setPlan(id);
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14" data-testid="pro-page">
      <div className="max-w-2xl">
        <div className="overline-label">Piani IdeaForge</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-4 leading-[1.05]">Più idee, piani illimitati, zero limiti.</h1>
        <p className="text-slate-400 mt-5 leading-relaxed">Il piano gratuito include 3 generazioni al giorno. Con Pro generi senza limiti: provalo gratis per 7 giorni, senza carta. Pagamento sicuro con Stripe o PayPal, disdici quando vuoi.</p>
      </div>
      <div className="mt-12"><ProTrial /></div>
      <div className="grid md:grid-cols-3 gap-6 mt-14">
        {TIERS.map((t) => (
          <div key={t.id} data-testid={`pricing-tier-${t.id}`}
            className={`relative rounded-3xl p-7 border flex flex-col transition-[transform,border-color] duration-300 hover:-translate-y-1 ${t.popular ? "bg-gradient-to-b from-amber-500/[0.12] to-[#12141F] border-amber-500/40" : "bg-[#12141F] border-white/[0.07] hover:border-white/20"}`}>
            {t.popular && <span className="absolute -top-3 left-7 text-xs font-semibold bg-amber-500 text-slate-950 rounded-full px-3 py-1">Più scelto</span>}
            <div className="font-display text-lg font-semibold">{t.name}</div>
            <div className="mt-4 flex items-baseline gap-1">
              <span className="font-display text-4xl font-extrabold">{t.price}</span>
              <span className="text-slate-500 text-sm">{t.note}</span>
            </div>
            <ul className="mt-6 space-y-3 flex-1">
              {t.features.map((f) => (
                <li key={f} className="flex gap-2.5 text-sm text-slate-300"><Check className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />{f}</li>
              ))}
            </ul>
            <button onClick={() => choose(t.id)} data-testid={`pricing-tier-${t.id}-btn`}
              className={`mt-8 rounded-full py-3 font-semibold text-sm transition-colors duration-200 ${t.popular ? "bg-amber-500 text-slate-950 hover:bg-amber-400" : "border border-white/15 text-slate-200 hover:border-amber-500/60 hover:text-amber-300"}`}>
              {t.id === "starter" ? "Lo stai già usando" : "Abbonati ora"}
            </button>
          </div>
        ))}
      </div>
      <div ref={formRef} id="abbonati" className="mt-14 space-y-6">
        <CheckoutForm key={presetEmail} plan={plan} planName={tier.name} price={tier.price} initialEmail={presetEmail} />
        <div className="rounded-2xl border border-white/[0.07] bg-[#0d0f17] p-5"><RecoverPro /></div>
      </div>
    </div>
  );
}
